import './index.css';

const AvatarName = ({ name = "" }) => {
  const initial = name.trim().charAt(0).toUpperCase();

  return (
     <div className="chip">
      <div className="chip-avatar">{initial}</div>
      <span className="chip-label">{name}</span>
    </div>
  );
};

export default AvatarName;
